class OhoraAccordion extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.ohora-acc-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.ohora-acc-item');
        const content = item.querySelector('.ohora-acc-content');
        const isActive = item.classList.contains('is-active');

        const video = content.querySelector('video');

        if (isActive) {
          content.style.height = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            content.style.height = '0';
          });
          item.classList.remove('is-active');
          if (video) video.pause();
        } else {
          content.style.height = content.scrollHeight + 'px';
          content.addEventListener('transitionend', () => {
            content.style.height = 'auto';
          }, { once: true });
          item.classList.add('is-active');
          if (video) video.play().catch(() => {});
        }
      });
    });
  }
}

if (!customElements.get('ohora-accordion')) {
  customElements.define('ohora-accordion', OhoraAccordion);
}
